import { getNewcomerProductCompare } from "@utils/api.js";

export class NewcomerSmartChoose {
    constructor({el}) {
        this.DOM = {
            cls: el,
            el: $(el)
        }
        if ($(this.DOM.cls).length === 0) {
            return;
        }
        this.init();
    }
    async init(){
        try {
            // 如果没有配置按钮文案则不发起网络请求
            const btnTitleText = $(`${this.DOM.cls} .higher-output-content .btn-title`).text().trim();
            if (!btnTitleText) {
                return;
            }

            // 检查是否已经有图片内容，如果有则不需要请求接口
            const hasImageContent = $('.smart-main-pop .pop-content').data('has-image');

            let higherTableDOM = '';
            if (!hasImageContent) {
                const { data } = await getNewcomerProductCompare();
                higherTableDOM = this.generateTableHTML(data);
            }

            $(`${this.DOM.cls} .higher-btn`).on('click',function(){
                $('.smart-main-pop').css('display', 'block');
                $('body').css('overflow', 'hidden');

                // 只有在没有图片内容时才设置表格HTML
                if (!hasImageContent) {
                    $('.smart-main-pop .pop-content').html(higherTableDOM);
                }

                if(window.innerWidth < 1024) {
                    setTimeout(() => {
                        $('.smart-main-pop .higher-output-box').css('transform', 'translateY(0)');
                    }, 50);
                }
            })
        }catch(err){
            console.error(err);
        }
        $('.pop-close-icon').on('click',function(){
            $('.smart-main-pop').css('display', 'none');
            $('body').css('overflow', 'auto');
            if(window.innerWidth < 1024) {
                $('.smart-main-pop .higher-output-box').css('transform', 'translateY(100%)');
            }
        })
    }

    isValidData(data) {
        // 至少一个字段的数组中，有超过1个项，且至少一个不是空字符串
        return Object.values(data).some(arr =>
          Array.isArray(arr) &&
          arr.length > 1 &&
          arr.some(item => item.trim() !== "")
        );
    }

    generateTableHTML(data) {
        if (!this.isValidData(data)) {
            return '<div class="empty-table">No data available</div>';
        }

        // 获取表头数据（第一行数据）
        const headers = data['1'] || [];
        // 获取所有行的键
        const rowKeys = Object.keys(data).sort((a, b) => parseInt(a) - parseInt(b));

        let tableHTML = '<div class="higher-table-container"><table class="higher-table">';

        // 生成表头
        tableHTML += '<thead>';
        tableHTML += '<tr class="main-header">';
        tableHTML += '<th></th>'; // 第一列为空


        let headerCells = [];

        if (headers.length <= 2) {
            // 特殊情况，直接渲染
            for (let i = 1; i < headers.length; i++) {
                headerCells.push({
                    text: headers[i],
                    colspan: 1
                });
            }
        } else {

            // 处理表头合并单元格
            let currentHeader = '';
            let headerColspan = 0;
            for (let i = 1; i < headers.length; i++) {
                if (i === 1 || (headers[i] === headers[i-1] && headers[i] !== '')) {
                    headerColspan++;
                } else {
                    if (headerColspan > 0) {
                        headerCells.push({
                            text: currentHeader,
                            colspan: headerColspan
                        });
                    }
                    headerColspan = 1;
                    currentHeader = headers[i];
                }

                // 如果是最后一个元素
                if (i === headers.length - 1) {
                    headerCells.push({
                        text: currentHeader,
                        colspan: headerColspan
                    });
                }

                // 更新当前标题
                if (headers[i] !== '' && (i === 1 || headers[i] !== headers[i-1])) {
                    currentHeader = headers[i];
                }
            }
        }

        // 渲染表头单元格（空值直接显示为空）
        headerCells.forEach(cell => {
            if (cell.text) {
                tableHTML += `<th colspan="${cell.colspan}" class="product-header">${cell.text}</th>`;
            } else {
                tableHTML += `<th colspan="${cell.colspan}" class="product-header"></th>`;
            }
        });

        tableHTML += '</tr>';
        tableHTML += '</thead>';

        // 生成表格内容
        tableHTML += '<tbody>';

        // 从第一行开始生成数据行（包括第二行）
        for (let i = 1; i < rowKeys.length; i++) {
            const rowKey = rowKeys[i];
            const rowData = data[rowKey];

            tableHTML += '<tr>';
            // 第一列是行标题（如果为空则保持空）
            tableHTML += `<td class="row-header">${rowData[0] || ''}</td>`;

            // 其余列是数据（除第一列外，空值用'-'替代）
            for (let j = 1; j < rowData.length; j++) {
                const cellValue = rowData[j] === '' ? '-' : rowData[j];
                tableHTML += `<td>${cellValue}</td>`;
            }

            tableHTML += '</tr>';
        }

        tableHTML += '</tbody></table></div>';

        // 添加样式
        tableHTML += `
        <style>
            .higher-table-container {
                max-height: 500px;
                overflow-y: auto;
                max-width: 100%;
                position: relative;
            }
            .higher-table {
                width: 100%;
                max-height: 100%;
                border-collapse: separate;
                border-spacing: 0;
                text-align: center;
                font-family: var(--jds-font-family);
            }
            .higher-table thead tr.main-header th {
                position: sticky;
                top: 0;
                z-index: 2;
                background-color: #e6e6e6;
            }
            .higher-table thead tr.main-header th:first-child{
                left: 0;
                z-index:3;
            }
            .higher-table th, .higher-table td {
                border: 1px solid #ddd;
                padding: 8px;
                vertical-align: middle;
                min-width: 80px;
            }
            .higher-table .row-header {
                position: sticky;
                left: 0;
                z-index: 1;
                font-weight: 500;
                text-align: left;
                font-size: 16px;
                color: #1A1A1A;
                background-color: #f9f9f9;
                min-width: 207px;
                max-width: 207px;
            }
            .higher-table thead th:first-child {
                position: sticky;
                left: 0;
                top: 0;
                z-index: 3;
                background-color: #e6e6e6;
                width: 207px;
            }
            .higher-table .product-header {
                background-color: #e6e6e6;
                font-weight: 500;
                font-size: 16px;
                color: #1A1A1A;
            }
            .higher-table-modal .new-modal-content {
                max-width: 90%;
                width: auto;
            }
            .higher-table tbody tr:nth-child(odd) td:not(.row-header) {
                background-color: #f5f5f5;
            }
            .higher-table tbody tr:nth-child(odd) td.row-header {
                background-color: #f9f9f9;
            }
            .higher-table tbody tr:nth-child(even) td:not(.row-header) {
                background-color: #ffffff;
            }
            .higher-table tbody tr:nth-child(even) td.row-header {
                background-color: #f9f9f9;
            }
            @media screen and (min-width: 1024px) and (max-width: 1439.98px) {
                .higher-table-container {
                    max-height: 34.722222vw;
                }
            }
            @media (max-width: 1024px) {
                .higher-table thead tr.main-header th{
                    position: unset;
                }

                .higher-table .row-header {
                    position: unset;
                }

                .higher-table thead th:first-child {
                    position: unset;
                }

                .higher-table th, .higher-table td {
                    padding: 5px;
                    font-weight: 400;
                    font-size: 3.733333vw;
                    color: #666666;
                    line-height: 4.26666667vw;
                    max-width: unset;
                }
                .higher-table tbody td:not(.row-header) {
                    min-width: 10.93333vw;
                    width: 10.93333vw;
                }
                .higher-table .product-header{
                    font-size: 3.733333vw;
                    color: #1A1A1A;
                    line-height: 4.26666667vw;
                    padding: 0.66666667vw 2.4vw;
                }
                .higher-table .row-header{
                    font-size: 3.733333vw;
                    min-height: 10.2666667vw;
                    max-width: unset;
                    width: 48.26666667vw;
                    line-height: 4.26666667vw;
                    padding: 0.66666667vw 3.2vw 0.66666667vw 3.733333vw;;
                }
                .higher-table-container {
                    max-height: 60vh;
                }
            }
        </style>
        `;

        return tableHTML;
    }
}
